import React from 'react';
import { Modal, Button, Header, Icon } from 'semantic-ui-react';
import translations from '../utils/translations';

const DeleteModal = ({ isOpen, onClose, onConfirm, current_locale = 'en', isRTL = false }) => {
  // Get translations based on locale
  const t = translations[current_locale] || translations['en'];
  return (
    <Modal
      size="tiny"
      open={isOpen}
      onClose={onClose}
      dimmer="blurring"
      className="ic-creator-modal"
      style={{ direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}
    >
      <Header icon>
        <Icon name="trash alternate" color="red" />
        {t.deleteIC}
      </Header>
      <Modal.Content>
        <p>{t.deleteConfirmation}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button color="grey" onClick={onClose}>
          <Icon name="remove" /> {t.cancel}
        </Button>
        <Button color="red" onClick={onConfirm}>
          <Icon name="trash alternate" /> {t.delete}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteModal;
